var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 24,
    viewBox: "0 0 128 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 5.03757L16.0234 9.0937C14.8039 8.07967 12.9746 7.47125 10.942 7.47125C7.35112 7.47125 4.60715 9.66832 4.60715 13.6569C4.60715 17.2736 7.24949 19.8425 11.1791 19.8425C12.1954 19.8425 13.1101 19.6735 13.7537 19.4707V13.7921L18.2254 13.6231V22.2761C16.5315 23.3578 13.8892 24 10.9759 24C4.26839 24 0 19.6059 0 13.6569C0 7.67405 4.47165 3.31371 10.6032 3.31371C13.5166 3.31371 15.7863 3.88833 17.4801 5.03757Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2903 3.61792L37.9516 7.60645H29.347V11.6288H36.4271V15.5159H29.347V19.7073H38.4597V23.6958H24.8415V3.61792H38.2903Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8131 3.61792V23.6958H57.9512L50.2952 12.9808C49.7193 12.1696 49.1773 11.3246 48.7708 10.5471H48.6014V23.6958H44.2991V3.61792H48.6691L55.817 13.6569C56.3929 14.4343 56.9349 15.2793 57.3414 16.0567H57.5108V3.61792H61.8131Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8958 3.61792V15.1779C85.8958 20.8227 82.6437 24 77.1896 24C71.7356 24 68.4835 20.8227 68.4835 15.1779V3.61792H72.989V14.8399C72.989 18.0172 74.3102 19.8763 77.2913 19.8763C80.2385 19.8763 81.5597 18.0172 81.5597 14.8399V3.61792H85.8958Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.291 3.61792V23.6958H109.786V11.3922H109.65C109.447 12.271 109.142 13.1498 108.668 14.2315L105.449 20.8227H101.215L98.0306 14.2315C97.5902 13.2174 97.2514 12.271 97.0482 11.3922H96.8788V23.6958H92.5765V3.61792H97.3531L102.163 13.6907C102.604 14.6709 103.112 15.9215 103.349 16.699H103.519C103.756 15.9215 104.264 14.6709 104.704 13.6907L109.515 3.61792H114.291Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.469 7.66985H123.653L122.996 5.79758H120.304L119.647 7.66985H117.909L120.703 0H122.687L125.469 7.66985ZM122.558 4.4418L121.94 2.68574C121.824 2.35002 121.747 2.06595 121.682 1.75606H121.618C121.554 2.06595 121.476 2.35002 121.36 2.68574L120.729 4.4418H122.558Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0V7.66985H126.287V0H128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.813f9dddb5a7b478792b9b96ece747f9.svg";
export { ForwardRef as ReactComponent };